export default __webpack_public_path__ + "static/media/genesis.f3d6a752.png";